var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9466_78905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0H1.99997C1.46973 0.000535717 0.961343 0.211475 0.58646 0.586461C0.211441 0.961343 0.000514289 1.46973 0 1.99997V14C0.000535717 14.5303 0.211475 15.0387 0.58646 15.4135C0.961343 15.7886 1.46973 15.9995 1.99997 16H14C14.5303 15.9995 15.0387 15.7885 15.4135 15.4135C15.7886 15.0387 15.9995 14.5303 16 14V1.99997C15.9995 1.46973 15.7885 0.961343 15.4135 0.586461C15.0387 0.211441 14.5303 0.000514289 14 0ZM15.2 14C15.1996 14.3182 15.0732 14.6231 14.8482 14.8481C14.6232 15.0731 14.3182 15.1996 14 15.2H1.99997C1.68175 15.1996 1.37678 15.0731 1.1518 14.8481C0.926817 14.6231 0.80037 14.3182 0.799959 14V1.9999C0.800361 1.68168 0.926789 1.37672 1.1518 1.15173C1.37681 0.926748 1.68176 0.800302 1.99997 0.79989H14C14.3183 0.800292 14.6232 0.926721 14.8482 1.15173C15.0732 1.37674 15.1996 1.68169 15.2 1.9999V14Z",
    fill: "#CC4B37",
    stroke: "#CC4B37",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10001 7.99996C9.10001 8.60747 8.60747 9.10001 7.99996 9.10001C7.39245 9.10001 6.8999 8.60747 6.8999 7.99996C6.8999 7.39245 7.39245 6.8999 7.99996 6.8999C8.60747 6.8999 9.10001 7.39245 9.10001 7.99996Z",
    fill: "#CC4B37",
    stroke: "#CC4B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09988 3.99982C5.09988 4.60733 4.60733 5.09988 3.99982 5.09988C3.39237 5.09988 2.8999 4.60738 2.8999 3.99982C2.8999 3.39231 3.39231 2.8999 3.99982 2.8999C4.60738 2.8999 5.09988 3.39237 5.09988 3.99982Z",
    fill: "#CC4B37",
    stroke: "#CC4B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0999 12C13.0999 12.6075 12.6075 13.0999 12 13.0999C11.3924 13.0999 10.8999 12.6074 10.8999 12C10.8999 11.3924 11.3924 10.8999 12 10.8999C12.6074 10.8999 13.0999 11.3924 13.0999 12Z",
    fill: "#CC4B37",
    stroke: "#CC4B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9466_78905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.767bb997ef89dfcc21049f00eed2239b.svg";
export { ForwardRef as ReactComponent };